import React, {useState} from "react";
import {Divider, Button} from "antd";
import {useStore} from "../../../../hooks/useStore";
import {InboxOutlined} from "@ant-design/icons";
import {StyledModal, ModalTitle, SectionTitle} from "./ShipmentTransferModal.styled";
import AcceptableMoveTransferTable from "./acceptableMoveTransferTable/AcceptableMoveTransferTable";
import {useFetch} from "../../../../hooks/useFetch";
import {AcceptableMoveShipmentTable} from "./acceptableMoveShipmentTable/AcceptableMoveShipmentTable";

const ShipmentTransferModal = ({isModalOpen, setIsModalOpen, transfer, refetchActiveTransfers}) => {
    const stores = useStore();
    const [selectedShipments, setSelectedShipments] = useState([]);
    const [selectedTransfer, setSelectedTransfer] = useState(null);

    const [
        acceptableMoveTransfersLoading,
        acceptableMoveTransfers,
        _,
        __,
        refetchAcceptableMoveTransfers
    ] = useFetch({
        fetchFn: () => stores.transferStore.acceptableMoveTransfer({transferId: transfer?._id}),
        dependencies: [transfer?._id],
        condition: isModalOpen
    });

    const [moveTransferLoading, moveTransfer, , , refetchMoveTransfer] = useFetch({
        fetchFn: () =>
            stores.transferStore.moveShipmentToTransfer({
                shipmentIds: selectedShipments,
                toTransferId: selectedTransfer?._id,
                fromTransferId: transfer?._id
            }),
        dependencies: [],
        initialCall: false,
        callbackFunc: result => {
            if (result?.success) {
                handleCancel();
                refetchActiveTransfers();
            }
        }
    });

    const [moveToNewTransferLoading, moveToNewTransfer, ___, ____, refetchNewTransfer] = useFetch({
        fetchFn: () =>
            stores.transferStore.moveShipmentToNewTransfer({
                shipmentIds: selectedShipments,
                transferId: transfer?._id
            }),
        dependencies: [],
        initialCall: false,
        callbackFunc: result => {
            if (result?.success) {
                handleCancel();
                refetchActiveTransfers();
            }
        }
    });

    const handleCancel = () => {
        setIsModalOpen(false);
        setSelectedShipments([]);
        setSelectedTransfer(null);
    };

    const handleMoveShipment = () => {
        refetchMoveTransfer({
            shipmentIds: selectedShipments,
            fromTransferId: transfer?._id,
            toTransferId: selectedTransfer?._id
        });
    };

    const handleMoveShipmentToNewTransfer = () => {
        refetchNewTransfer({
            shipmentIds: selectedShipments,
            transferId: transfer?._id
        });
    };

    return (
        <StyledModal
            title={
                <ModalTitle level={4}>
                    <InboxOutlined style={{marginRight: 8}} /> Shipment Aktar
                </ModalTitle>
            }
            visible={isModalOpen}
            onOk={handleMoveShipment}
            onCancel={handleCancel}
            confirmLoading={moveTransferLoading || moveToNewTransferLoading}
            okText="Transfer Et"
            cancelText="İptal"
            width={"80%"}
            cancelButtonProps={{
                style: {
                    borderColor: "#d9d9d9"
                }
            }}
        >
            <SectionTitle>Aktarılacak Shipmentlar</SectionTitle>
            <AcceptableMoveShipmentTable
                transfer={transfer}
                selectedShipments={selectedShipments}
                setSelectedShipments={setSelectedShipments}
            />
            <Divider style={{margin: "24px 0 16px"}} />
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <SectionTitle>Aktarılabilecek Transferler</SectionTitle>
                <Button
                    style={{marginBottom: "16px"}}
                    type="primary"
                    onClick={handleMoveShipmentToNewTransfer}
                    disabled={selectedShipments.length === 0}
                >
                    Yeni Transfer Oluştur
                </Button>
            </div>
            <AcceptableMoveTransferTable
                acceptableMoveTransfers={acceptableMoveTransfers}
                acceptableMoveTransfersLoading={acceptableMoveTransfersLoading}
                setSelectedTransfer={setSelectedTransfer}
                isModalOpen={isModalOpen}
            />
        </StyledModal>
    );
};

export default ShipmentTransferModal;
